import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "@/components/Reveal";
import { GraduationCap, Cpu, Monitor, Award } from "lucide-react";

const icons = [GraduationCap, Cpu, Monitor, Award];

export default function Professional() {
  const { t } = useLang();
  return (
    <section id="professional" data-testid="professional-section" className="bg-icdh-white py-28 md:py-40">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <Reveal><Overline>{t.professional.overline}</Overline></Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-icdh-navy">
                {t.professional.title}
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-8 text-icdh-navy/70 text-lg max-w-md">{t.professional.lead}</p>
            </Reveal>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-px bg-icdh-navy/10 border border-icdh-navy/10">
            {t.professional.items.map((p, i) => {
              const Icon = icons[i % icons.length];
              return (
                <Reveal key={i} delay={(i % 2) * 0.1}>
                  <div data-testid={`pro-item-${i}`} className="group bg-icdh-white p-8 md:p-10 hover:bg-icdh-surface transition-colors duration-500 h-full flex flex-col">
                    <Icon className="text-icdh-red group-hover:scale-110 transition-transform duration-500" size={28} />
                    <h3 className="mt-6 font-serif text-2xl tracking-tight text-icdh-navy">{p.t}</h3>
                    <p className="mt-3 text-icdh-navy/65 text-sm flex-1">{p.d}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
